import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import {
  Typography,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core';

import { usePageBallotCopyStyles as useStyles } from '../styles';
import AppInput from '../../../../common/AppInput';
import AuthorizeCheckbox from '../../../mis-compras/components/report-issue-view/forms/authorizeThird/AuthorizeCheckbox';
import LoadingButton from '../../../../common/LoadingButton';
import { bodyIssueTicketGenerator } from '../../../../../helpers/tickets/TicketsHelper';
import { createTicketNoProduct } from '../../../../../redux/actions/TicketActions';
import { REQUEST_NOT_PRODUCT_TICKET } from '../../../../../constants/Routes';
import { isNumber } from '../../../../../helpers/OnlyNumbers';

const problems = [
  'No tengo saldo en mi Gift Card',
  'No funciona la clave de mi Gift Card',
  'Mi gift Card está bloqueada',
];

const giftCardMessage = 'Ingresa 7 o 20 dígitos';

const GiftCardProblem = (props) => {
  const { mobile, motiveId, type } = props;
  const [selectedProblem, setSelectedProblem] = useState('');
  const [giftCardNumber, setGiftCardNumber] = useState('');
  const [comment, setComment] = useState('');
  const [helperComment, setHelperComment] = useState('0/150');
  const [errorGiftCard, setErrorGiftCard] = useState(false);
  const [successGiftCard, setSuccessGiftCard] = useState(false);
  const [errorComment, setErrorComment] = useState(false);
  const [successComment, setSuccessComment] = useState(false);
  const [checked, setChecked] = useState(false);
  const { profile } = useSelector((state) => state.profileReducer);
  const { ticketNoProductStatus } = useSelector(
    (innerState) => innerState.ticketReducer,
  );
  const classes = useStyles({ mobile });
  const dispatch = useDispatch();
  const history = useHistory();

  const validateForm = () =>
    !(successComment && successGiftCard && selectedProblem !== '');

  const changeRadioButton = (event) => {
    setSelectedProblem(event.target.value);
  };

  const onChangeComment = (event) => {
    const { value } = event.target;
    setComment(value);
    setHelperComment(`${value.length}/150`);
    if (value.length > 150 || value.length < 20) {
      setErrorComment(true);
      setSuccessComment(false);
    } else {
      setErrorComment(false);
      setSuccessComment(true);
    }
  };

  const validateGiftCard = (event) => {
    const { value } = event.target;
    setGiftCardNumber(value);
    const isNumeric = isNumber(value);
    if (isNumeric && (value.length === 20 || value.length === 7)) {
      setSuccessGiftCard(true);
      setErrorGiftCard(false);
    } else {
      setSuccessGiftCard(false);
      setErrorGiftCard(true);
    }
  };

  const onClickButton = () => {
    const newComment = `Giftcard: ${giftCardNumber} - Motivo: ${selectedProblem} - Comentario: ${comment}`;
    const body = bodyIssueTicketGenerator({
      profile,
      type,
      motiveId,
      comment: newComment,
    });
    dispatch(createTicketNoProduct(body));
  };

  useEffect(() => {
    if (ticketNoProductStatus === 'succeded') {
      setComment('');
      setErrorGiftCard(false);
      setSuccessGiftCard(false);
      setErrorComment(false);
      setSuccessComment(false);
      history.push(REQUEST_NOT_PRODUCT_TICKET);
    }
  }, [ticketNoProductStatus]);

  return (
    <Box
      className={classes.container}
      margin={mobile ? '0px -16px' : '0px 50px'}
      width={mobile ? 'auto' : '75%'}
    >
      <Typography className={classes.titleRadioButton}>
        Selecciona el inconveniente que tienes con tu Gift Card:
      </Typography>
      <RadioGroup value={selectedProblem} onChange={changeRadioButton}>
        {problems.map((problem, index) => (
          <FormControlLabel
            key={index}
            value={problem}
            control={<Radio color="primary" />}
            label={problem}
            data-cy={`problemSelector-${index}`}
            className={classes.radioButton}
          />
        ))}
      </RadioGroup>
      <AppInput
        name="GiftCardNumber"
        helperText={giftCardMessage}
        label={'Nº de tu Gift Card'}
        value={giftCardNumber}
        onClick={() => {}}
        onBlur={validateGiftCard}
        onChange={validateGiftCard}
        error={errorGiftCard}
        errorMessage={giftCardMessage}
        success={successGiftCard}
      />
      <AppInput
        name="comment"
        helperText={helperComment}
        label="Describe tu inconveniente..."
        error={errorComment}
        errorMessage={helperComment}
        success={successComment}
        value={comment}
        onClick={() => {}}
        onBlur={onChangeComment}
        onChange={onChangeComment}
        multiline
      />
      <AuthorizeCheckbox
        idComplement="giftCardProblemForm"
        disabled={validateForm()}
        onCheck={() => setChecked(!checked)}
      />
      <LoadingButton
        name="SentProblemGiftCard"
        variant="contained"
        color="primary"
        text="Enviar"
        className={classes.button}
        disabled={!(!validateForm() && checked)}
        onClick={onClickButton}
        loading={ticketNoProductStatus === 'loading'}
      />
    </Box>
  );
};

GiftCardProblem.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.number,
  type: PropTypes.number,
};

export default GiftCardProblem;
